import React from "react";
import { Helmet } from "react-helmet";
import { Button, Form, Tabs, notification, Spin } from "antd";
import { useMemo, useState, useEffect } from "react";
import BlogForm from "./blogForm";
import SeoForm from "./seoMetaForm";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import { useParams } from "react-router-dom";
import "react-draft-wysiwyg/dist/react-draft-wysiwyg.css";
const EditBlog = () => {
  const [file, setFile] = useState([]);
  const [loader, setLoader] = useState(true);
  const [loader2, setLoader2] = useState(false);
  const [editBlog, setEditBlog] = useState({});
  const [isUploading, setIsUploading] = useState(false);
  const { id } = useParams();
  const navigate = useNavigate();
  const openNotification = (message, description) => {
    notification.open({
      message,
      description,
    });
  };
  // useEffect to get content
  useEffect(() => {
    axios
      .get(`${process.env.REACT_APP_FRONTED_URL}/blogs/${id}`)
      .then((response) => {
        console.log("response?.data?", response?.data);
        const data = {
          title: response?.data?.title[0],
          title2: response?.data?.title[1],
          SubTitleAndContent: response?.data?.SubTitleAndContent,
          shortDescription: response?.data?.shortDescription,
          metaTitle: response?.data?.metaData[0].title,
          metaDescription: response?.data?.metaData[0].description,
          metaKeywords: response?.data?.metaData[0].keywords,
        };
        setEditBlog(data);
        setLoader(false);
      })
      .catch((error) => {
        openNotification("Error", error?.response?.data?.message);
        setLoader(false);
      });
  }, []);
  const uploadProps = useMemo(
    () => ({
      beforeUpload: (file) => {
        const isImage = file?.type?.split("/")[0] === "image";
        const isValidSize = file.size <= 5 * 1024 * 1024;
        if (!isImage) {
          openNotification("Error", "Please upload an image file.");
          return false;
        }
        if (!isValidSize) {
          openNotification("Error", "File size exceeds 5MB limit.");
          return false;
        }
        const sanitizedFileName = file.name.replace(/\s+/g, "");
        const updatedFile = new File([file], sanitizedFileName, {
          type: file.type,
          uid: file.uid,
        });
        setFile([updatedFile]);
        return false;
      },
      onRemove: () => setFile([]),
    }),
    []
  );
  const uploadFiles = async (file) => {
    try {
      const response = await axios.post(
        `${process.env.REACT_APP_FRONTED_UPLOAD_IMAGE_URL}/getSignUrlForUpload`,
        {
          file: file[0],
        },
        {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        }
      );
      return response?.data?.publicUrl || null;
    } catch (error) {
      openNotification("Error", error?.response?.data?.message);
      return null;
    }
  };
  console.log("file", file);
  const onFinish = async (values) => {
    setLoader2(true);
    try {
      // payload
      let payload = {
        title: [values.title, values.title2],
        domain: "Gng",
        SubTitleAndContent: values.SubTitleAndContent,
        shortDescription: values.shortDescription,
        metaData: [
          {
            title: values.metaTitle,
            description: values.metaDescription,
            keywords: values.metaKeywords,
          },
        ],
      };
      let fileToUpload = false;
      if (file.length > 0) {
        openNotification(
          "Notification",
          "Please wait, file upload may take some time."
        );
        fileToUpload = file.length > 0 ? await uploadFiles(file) : false;
      }

      // if file is uploaded to add in payload then
      if (fileToUpload !== false) {
        payload = { ...payload, image: fileToUpload };
      }
      axios
        .put(`${process.env.REACT_APP_FRONTED_URL}/blogs/${id}`, payload)
        .then(() => {
          setIsUploading(false);
          setLoader2(false);
          navigate("/gng-blogs");
          openNotification("success", "Blog Updated successfully");
        })
        .catch((error) => {
          setIsUploading(false);
          setLoader2(false);
          console.error("Error creating blog:", error);
          openNotification("Error", error?.response?.data?.message);
        });
    } catch (error) {
      openNotification("Error", error?.message || "Something went wrong.");
    }
  };

  const items = [
    {
      key: "1",
      label: "SEO Meta Tags",
      children: <SeoForm />,
    },
    {
      key: "2",
      label: "Blog Details",
      children: (
        <BlogForm
          imgRequired={false}
          uploadProps={uploadProps}
          file={file}
          showPlaceholder={false}
        />
      ),
    },
  ];
  return (
    <React.Fragment>
      <Helmet>
        <title>Edit Duomo Blogs</title>
        <meta name="description" content="Add and manage Duomo blogs" />
      </Helmet>
      <div className="header">
        <h3>Add Blogs</h3>
      </div>
      {!loader ? (
        <div className="form_container">
          <Form
            layout="vertical"
            onFinish={onFinish}
            initialValues={{
              title: editBlog.title,
              title2: editBlog.title2,
              SubTitleAndContent: editBlog.SubTitleAndContent,
              shortDescription: editBlog.shortDescription,
              metaTitle: editBlog.metaTitle,
              metaDescription: editBlog.metaDescription,
              metaKeywords: editBlog.metaKeywords,
            }}
          >
            <Tabs defaultActiveKey="1" items={items} />
            <Form.Item>
              <div className="form_submit">
                <Button className="back_button" onClick={() => navigate(-1)}>
                  Back
                </Button>
                <Button htmlType="submit" type="primary">
                  {loader2 ? "Please Wait" : "Save"}
                </Button>
              </div>
            </Form.Item>
          </Form>
        </div>
      ) : (
        <div className="spin_information">
          <Spin />
        </div>
      )}
    </React.Fragment>
  );
};
export default EditBlog;
